<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-border
      tw-border-solid
      tw-border-sf-slate-lighter-1
      tw-rounded-lg
      tw-overflow-hidden
    "
    :class="open ? 'tw-min-h-0' : 'tw-shrink-0'"
  >
    <button
      type="button"
      class="
        tw-flex
        tw-shrink-0
        tw-items-center
        tw-justify-between
        tw-w-full
        tw-px-4
        tw-py-3
        tw-bg-sf-slate-subtle-1
        tw-border-none
        tw-cursor-pointer
        tw-text-left
      "
      :aria-expanded="open"
      @click="open = !open"
    >
      <span
        class="
          tw-flex
          tw-items-center
          tw-gap-2
          tw-font-sans
          tw-font-bold
          tw-text-sf-slate
        "
      >
        <i :class="iconClass" class="tw-w-4 tw-text-xs" />
        {{ title }}
      </span>
      <i
        class="fa fa-solid fa-chevron-down tw-text-xs tw-transition-transform"
        :class="{ 'tw-rotate-180': open }"
      />
    </button>

    <ul
      v-show="open"
      class="tw-list-none tw-p-0 tw-m-0 tw-flex-1 tw-min-h-0 tw-overflow-y-auto"
    >
      <li
        v-for="account in items"
        :key="account.id"
        class="
          tw-border-solid
          tw-border-x-0
          tw-border-t
          tw-border-b-0
          tw-border-sf-slate-lighter-1
        "
      >
        <a
          v-tooltip.placementBottom="accountTooltip(account)"
          :href="account.href"
          class="
            tw-flex
            tw-items-center
            tw-gap-2
            tw-px-4
            tw-py-3
            tw-text-sm
            tw-text-inherit
            tw-no-underline
            hover:tw-text-sf-primary-dark
            hover:tw-no-underline
            hover:tw-bg-sf-slate-subtle-1
          "
        >
          <span class="tw-truncate">{{ account.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import I18n from '@app/adapters/I18n'
import type { TemplateStarringAccountItem } from '@app/insights/types'

interface Props {
  title: string
  iconClass: string
  items: TemplateStarringAccountItem[]
}
defineProps<Props>()

const open = ref(true)

function accountTooltip(account: TemplateStarringAccountItem): string | null {
  // Accounts auto-starred at ledger creation have a date but no user, so show
  // whatever we know rather than suppressing the tooltip entirely.
  if (!account.starred_at) return null

  if (account.starred_by) {
    return I18n.t(
      'companies_overview.filters.template_starring.starred_by_on',
      { user: account.starred_by, date: account.starred_at }
    )
  }

  return I18n.t('companies_overview.filters.template_starring.starred_on', {
    date: account.starred_at,
  })
}
</script>
